function TypedArray3D(TypedArray) {
  return class {
    constructor(w, h = w, d = w) {
      this.w = w;
      this.h = h;
      this.d = d;

      this.data = new TypedArray(w * h * d);
    }

    coords(i) {
      const x = i % this.w;
      const y = Math.floor(i / this.w) % this.h;
      const z = Math.floor(i / (this.w * this.h));

      return { x, y, z };
    }

    index(x, y, z) {
      return (
        x +
        y * this.w +
        z * this.w * this.h
      );
    }

    get(x, y, z) {
      return this.data[this.index(x, y, z)];
    }

    set(x, y, z, v) {
      this.data[this.index(x, y, z)] = v;
    }
  }
}

class TypedSubArray3D {
  constructor(parent, x0, y0, z0, sx, sy, sz) {
    this.parent = parent;

    this.x0 = x0;
    this.y0 = y0;
    this.z0 = z0;

    // could be used to check bounds
    this.sx = sx;
    this.sy = sy;
    this.sz = sz;
  }

  get(x, y, z) {
    return this.parent.get(this.x0+x, this.y0+y, this.z0+z);
  }

  set(x, y, z, v) {
    return this.parent.set(this.x0+x, this.y0+y, this.z0+z, v);
  }
}


const Uint8Array3D = TypedArray3D(Uint8Array);
const Uint16Array3D = TypedArray3D(Uint16Array);
const Uint32Array3D = TypedArray3D(Uint32Array);

const Int8Array3D = TypedArray3D(Int8Array);
const Int16Array3D = TypedArray3D(Int16Array);
const Int32Array3D = TypedArray3D(Int32Array);

const Float16Array3D = TypedArray3D(Float16Array);
const Float32Array3D = TypedArray3D(Float32Array);
const Float64Array3D = TypedArray3D(Float64Array);

const BigInt64Array3D = TypedArray3D(BigInt64Array);
const BigUint64Array3D = TypedArray3D(BigUint64Array);

export {
  TypedSubArray3D,

  Uint8Array3D,
  Uint16Array3D,
  Uint32Array3D,

  Int8Array3D,
  Int16Array3D,
  Int32Array3D,

  Float16Array3D,
  Float32Array3D,
  Float64Array3D,

  BigInt64Array3D,
  BigUint64Array3D,
}
